<template>
        <div class="d-flex row justify-content-center home">
            <div class="col-md-12 px-0 mx-0">
                <!--                <div class="header-show-image-parallax"></div>-->
                <div class="header-show-image header-show-image-parallax " v-if="header.active">
                    <div class=" header-title-block d-flex flex-column">
                        <h1 class="text-start">{{ header.title }}</h1>
                        <p class="text-start">{{ header.description }}</p>

                        <div class="d-flex flex-column flex-md-row btn__block mb-5 mb-md-0">
                            <a href="/client-model" class="btn mb-4 mb-md-0 text-decoration-none btn-light-purple btn__block__btn me-md-3">{{
                                    nameBtn.requestBtn && nameBtn.requestBtn
                                }}</a>
                            <a href="/gallery" class=" ms-md-3 btn text-decoration-none btn-light-purple btn__block__btn_second">{{
                                    nameBtn.galleryBtn && nameBtn.galleryBtn
                                }}</a>
                        </div>
                        <img loading="lazy" src="/images/bg-home-mobile.png" style="width: 100%" alt="" class="d-sm-none">
                    </div>
                </div>
                <div class="partners-banner main-padding" v-if="sectionImg.partners == 1">

<!--                    <VueSlickCarousel :infinite="true" :autoplay="true" :edgeFriction="1" :dotsClass="'slick-dots custom-dot-class'"  :dots="true" v-if="partners.length > 0">-->
<!--                        <img v-for="partner in partners" class="image-parners" :src="partner" alt="partner" style="">-->
<!--                    </VueSlickCarousel>-->
                  <Swiper
                      v-if="partners.length > 0"
                      :loop="true"
                      :slides-per-view="1"
                      :space-between="20"
                      class="swiper-partners"
                  >
                    <SwiperSlide v-for="(partner, index) in partners" :key="index">
                      <img class="image-parners" :src="partner" alt="partner" />
                    </SwiperSlide>
                  </Swiper>
                </div>

                <div class="about-3d main-padding" v-if="mainInfo.active">
                    <div class="d-flex flex-column flex-md-row justify-content-between block-info">
                        <div class="col-md-6">
                            <h1 class="mb-3" v-html="mainInfo.title"></h1>
                            <div class="block-info__text">
                                <p v-html="this.mainInfo.description"></p>
                            </div>
                        </div>
                        <img :src="images.about3D" v-if="sectionImg.about == 1" class="col-md-6" alt="about-3d" style="border-radius: 40px">
                    </div>
                </div>

                <div class="services-3d main-padding" v-if="servicesActive">
                    <p v-html="servicesTitle"></p>

                    <div class="absolute-home-image-right d-none d-xl-block"></div>

                    <div class="d-flex flex-column flex-md-row our-services">
                        <div v-for="service in services" class="col-12 col-md-4 item-service ">
                            <a :href="service.link" class="text-decoration-none">
                                <div class="service d-flex flex-column align-items-center">
                                    <img :src="service.img" alt="image">
                                    <h2 class="title-service">{{ service.title }}</h2>
                                    <p class="description-service" v-html="service.description"></p>
                                    <div class="d-flex">
                                        <a class='my-auto' href="">{{ lang === 'ar-sa' ? 'عرض المزيد' : 'Show More' }}</a>
                                        <img class="my-auto" src="../../../../public/images/icons/arrow/right-arrow.svg" alt="">
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <div v-if="this.products.length > 0"
                     class="gallery-demo main-padding">
                    <p class="mb-5" v-html="sectionGalleryTitle"></p>
                    <div class="absolute-home-image-left d-none d-md-block"></div>
                    <CardModelComponent class="justify-content-center"
                                        :products="this.products" :place="'home'" :lang="lang" />
                </div>

                <div class="partners-banner main-padding h-auto" v-if="sectionImg.logos == 1">
                    <p v-html="titles.partners"></p>

                    <div class="d-flex logos__block flex-column justify-content-between flex-md-row flex-wrap justify-content-xxl-around">
                        <div class="col-md-6 me-xl-1 col-xl-3 col-xxl-2 d-flex mb-4 mb-xxl-0 justify-content-center col-12"
                             v-for="logo in logos">
                            <img :src="logo" alt="brand">
                        </div>

                    </div>
                </div>
            </div>
        </div>
</template>

<script type="application/javascript">
import CardModelComponent from "./CardModelComponent";
// import VueSlickCarousel from 'vue-slick-carousel'
// import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';


export default {
    components: {
        CardModelComponent,
        // VueSlickCarousel
      Swiper,
      SwiperSlide
    },
    data() {
        return {
            sectionGalleryTitle: '',
            logos: [],
            partners: [],
            images: {
                about3D: ''
            },
            servicesTitle: '',
            servicesActive: false,
            lang: '',
            services: [
                {
                    img: '/images/icons/print-main.svg',
                    title: 'Print your 3D model',
                    link: '/client-model',
                },
                {
                    img: '/images/icons/coub.svg',
                    title: 'Design & Print',
                    link: '/request-create',
                },
                {
                    img: '/images/icons/3d.svg',
                    title: 'Gallery',
                    link: '/gallery',
                },
            ],
            products: [],
            header: {
                active: false,
                title: '',
                description: ''
            },
            mainInfo: {
                active: false,
                description: '',
                title: '',
                image: ''
            },
            nameBtn: {
                galleryBtn: 'Explore our Gallery',
                requestBtn: 'Print your 3D Print '
            },
            sectionImg: {
                partners: 1,
                logos: 1,
                about: 1
            },
            titles: {
                partners: ''
            }

        }
    },

    methods: {

        changeContent() {
            let mainImage = document.querySelector('.header-show-image-parallax')
            if (window.currentLang === 'ar-sa') {
                this.lang = 'ar-sa'
                content[0].active && this.getContent(content[0].content_ar, 0, content[0].active)
                content[1].active && this.getContent(content[1].content_ar, 1, content[1].active)
                content[2].active && this.getContent(content[2].content_ar, 2, content[2].active)
                this.nameBtn.galleryBtn = 'تصفح معرض النماذج والمنتجات'
                this.nameBtn.requestBtn = 'طلب طباعة ثلاثية الأبعاد'

                this.services[0].title = 'طباعة نماذج ثلاثية الأبعاد'
                this.services[1].title = 'تصميم النماذج والطباعة'
                this.services[2].title = 'معرض النماذج والمنتجات الجاهزة'

                this.sectionGalleryTitle = 'معرض النماذج والمنتجات'
                this.titles.partners = 'شركائنا'
            } else {
                this.lang = 'en'
                this.titles.partners = 'Our partners'

                content[0].active && this.getContent(content[0].content_en, 0, content[0].active)
                content[1].active && this.getContent(content[1].content_en, 1, content[1].active)
                content[2].active && this.getContent(content[2].content_en, 2, content[2].active)
                this.sectionGalleryTitle = 'Gallery'

                this.nameBtn.galleryBtn = 'Explore our Gallery'
                this.nameBtn.requestBtn = 'Print your 3D Print '

                this.services[0].title = 'Print your 3D model'
                this.services[1].title = 'Design & Print'
                this.services[2].title = 'Gallery'
            }
            this.images.about3D = images[1].images
            this.logos = images[2].images
            this.partners = images[3].images
            this.sectionImg.partners = images[3].active
            this.sectionImg.logos = images[2].active
            this.sectionImg.about = images[1].active


            // mainImage && (mainImage.style.backgroundImage = `url(/${images[0].images})`)
        },

        getContent(lang, index, status) {
            if (index === 0) {
                this.header.active = status
                this.header.title = lang.title.replace(/<\/?[a-zA-Z]+>/gi, '')
                this.header.description = lang.description.replace(/<\/?[a-zA-Z]+>/gi, '')
            } else if (index === 1) {
                this.mainInfo.active = status
                this.mainInfo.title = lang.title
                this.mainInfo.description = lang.description
            } else if (index === 2) {
                this.servicesTitle = lang.title
                this.servicesActive = status
                this.services[0].description = lang.print
                this.services[1].description = lang.design
                this.services[2].description = lang.gallery
            }
        },
        getPopularModel() {
            let vm = this
            axios.get('/populars').then(function (response) {
                vm.products = response.data.data

                vm.products.forEach(item => {
                    if ( item.file_hash !== null) {
                        item.dynamic_img = '/storage/models_dynamic_mp4/' + item.file_hash + '_' + item.file_size + '_' + item.color.replace('#', '') + '.mp4';
                        item.dynamic_img_ready = false;
                        item.mouseover = false;
                        item.hover = false;
                    }
                });
                vm.products.splice(4)
            })
        },
        getBestDeals() {
            axios.get('/get-best-deals')
                .then( (response) => {

                    this.products = response.data;
                })
        }
    },

    mounted() {
        // this.getPopularModel()
        this.getBestDeals();
    },
    updated() {
        let liLang = document.querySelectorAll('.js-change-lang li')
        this.changeContent()
        liLang.forEach(li => {
            li.addEventListener('click', e => {
                this.changeContent()
            })
        })
    }
}
</script>

<style lang="scss">
@import "../../sass/front/home";
@import "../../sass/front/card-model";
</style>
